import React from 'react'

export const ImageRoot = ({ children, size, className }) => {
  return <figure className={`image ${size} ${className}`}>{children}</figure>
}
